import React, { useState } from 'react';
import i18next from 'i18next';
import Icon from '@mdi/react';
import { Box, Button, Menu, MenuItem } from '@mui/material';
import { supportedLanguages } from '../../../../locales';
import { mdiWeb } from '@mdi/js';
import { useDispatch } from 'react-redux';
import { saveUserLanguage } from '../../../../Redux/UserSettingsSlice';
import type { AppDispatch } from '../../../../Redux/initStore';

export default () => {
    const dispatch: AppDispatch = useDispatch();
    const [anchorEl, setAnchorEl] = useState<HTMLElement | undefined>(undefined);

    const onLanguageSelect = (language: string) => {
        if (language && i18next.language !== language) {
            i18next.changeLanguage(language);
            dispatch(saveUserLanguage(language));
        }
    };

    return (
        <>
            <Button
                title={i18next.t(`languageControl.${i18next.language}`, i18next.language?.toUpperCase())}
                onClick={e => setAnchorEl(e.currentTarget)}
            >
                {<Icon path={mdiWeb} size={1} />}
                {<Box sx={{ pl: 1, fontSize: '16px', fontFamily: '"CeraPro Bold", sans-serif' }}>{i18next.language?.toUpperCase()}</Box>}
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(undefined)}
                onClick={() => setAnchorEl(undefined)}
            >
                {supportedLanguages.map(lang => (
                    <MenuItem
                        selected={lang === i18next.language}
                        key={lang}
                        onClick={() => onLanguageSelect(lang)}
                    >
                        {i18next.t(`languageControl.${lang}`, lang.toUpperCase())}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};
